import React from "react";

const CARD_THEMES = {
    "Total Students": { border: "#bfdbfe", gradient: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)", color: "#1d4ed8" },
    "Attended":       { border: "#bbf7d0", gradient: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)", color: "#15803d" },
    "Absent":         { border: "#fecaca", gradient: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)", color: "#b91c1c" },
    "Average Marks":  { border: "#bae6fd", gradient: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)", color: "#0369a1" },
    "Highest Marks":  { border: "#fde68a", gradient: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)", color: "#b45309" },
    "Lowest Marks":   { border: "#fed7aa", gradient: "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)", color: "#c2410c" },
};

function StatCard({ label, value, color, bg, icon }) {
    const theme = CARD_THEMES[label] || { border: "#e2e8f0", gradient: bg, color };
    return (
        <div
            className="stat-card-item h-100 d-flex align-items-center"
            style={{
                borderRadius: 14,
                padding: "14px 16px",
                border: `1px solid ${theme.border}`,
                background: "#fff",
                gap: 12,
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
                cursor: "default",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.03)";
            }}
        >
            <div
                style={{
                    width: 42,
                    height: 42,
                    borderRadius: 12,
                    background: theme.gradient,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    border: `1px solid ${theme.border}`,
                }}
            >
                <i className={icon} style={{ color: theme.color, fontSize: 18 }} />
            </div>
            <div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "#1f2937", lineHeight: 1.1 }}>
                    {value ?? "-"}
                </div>
                <div style={{ fontSize: 11.5, fontWeight: 600, color: "#64748b", marginTop: 3 }}>
                    {label}
                </div>
            </div>
        </div>
    );
}

export function StatisticsCards({ overall }) {
    const cards = [
        { label: "Total Students", value: overall.totalStudents, color: "#1d4ed8", bg: "#eff6ff", icon: "fal fa-user-graduate" },
        { label: "Attended", value: overall.attended, color: "#15803d", bg: "#f0fdf4", icon: "fal fa-user-check" },
        { label: "Absent", value: overall.absent, color: "#b91c1c", bg: "#fef2f2", icon: "fal fa-user-times" },
        { label: "Average Marks", value: overall.averageMarks, color: "#2563eb", bg: "#eff6ff", icon: "fal fa-chart-bar" },
        { label: "Highest Marks", value: overall.highestMarks, color: "#15803d", bg: "#f0fdf4", icon: "fal fa-arrow-up" },
        { label: "Lowest Marks", value: overall.lowestMarks, color: "#b91c1c", bg: "#fef2f2", icon: "fal fa-arrow-down" },
    ];
    return (
        <div className="row g-3">
            {cards.map((c) => (
                <div className="col-6 col-sm-4 col-md-3 col-lg-2" key={c.label}>
                    <StatCard {...c} />
                </div>
            ))}
        </div>
    );
}

export function PerformanceSegments({ segments, totalAttended }) {
    return (
        <div style={{ background: "#f8fafc", padding: "16px 18px", borderRadius: 14, border: "1px solid #e2e8f0" }}>
            <div style={{ display: "flex", height: 16, borderRadius: 20, overflow: "hidden", background: "#e2e8f0", padding: 2 }}>
                {segments.map((s) => {
                    const pct = totalAttended ? (s.count / totalAttended) * 100 : 0;
                    return pct > 0 ? (
                        <div
                            key={s.key}
                            style={{
                                width: `${pct}%`,
                                background: s.color,
                                borderRadius: 10,
                                transition: "width 0.3s ease",
                            }}
                            title={`${s.key}: ${s.count} (${Math.round(pct)}%)`}
                        />
                    ) : null;
                })}
            </div>
            <div className="d-flex flex-wrap mt-3" style={{ gap: 10 }}>
                {segments.map((s) => (
                    <div
                        key={s.key}
                        className="d-flex align-items-center"
                        style={{
                            background: "#fff",
                            border: "1px solid #e2e8f0",
                            borderRadius: 20,
                            padding: "4px 12px",
                            gap: 6,
                            fontSize: 12,
                        }}
                    >
                        <span style={{ width: 8, height: 8, borderRadius: "50%", background: s.color, display: "inline-block" }} />
                        <span style={{ fontWeight: 800, color: "#1f2937" }}>{s.count}</span>
                        <span style={{ color: "#64748b", fontWeight: 600 }}>{s.key}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default StatisticsCards;
